import React from 'react'

export type PrerequisitesErrorsProps = {
  errors: string[]
}
export const PrerequisitesErrors = ({ errors }: PrerequisitesErrorsProps) => {
  if (errors.length === 1) {
    return <>Your TikTok Shop has been disabled by TikTok due to: {errors[0]}</>
  }

  return (
    <>
      Your TikTok Shop has been disabled by TikTok due to:{' '}
      <ul>
        {errors.map((error) => (
          <li>{error}</li>
        ))}
      </ul>
    </>
  )
}
